import { Component, ViewEncapsulation } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { CardModule } from 'primeng/card';
import { FieldsetModule } from 'primeng/fieldset';
import { PermissionService } from '../../services/permission.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [CardModule,AvatarModule,FieldsetModule,CommonModule],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.css',
  encapsulation: ViewEncapsulation.None
})
export class LandingComponent {
  constructor( private readonly permission : PermissionService){}
 
  get accessPermission(){
    return this.permission
  }
}
